import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

export function Footer() {
  return (
    <footer
      className="w-full"
      style={{
        backgroundColor: 'rgb(27, 30, 40)',
        fontFamily: 'var(--dreamdev-font-family)',
        marginBottom: '100px'
      }}
    >
      <div
        className="mx-auto px-4 py-12"
        style={{
          maxWidth: '1200px'
        }}
      >
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start space-y-8 lg:space-y-0">
          {/* Left Column - Logo, Socials, and Legal Links */}
          <div className="flex flex-col items-center space-y-6">
            {/* Logo */}
            <a
              href="https://dreamdev.io"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2"
            >
              <img
                src="/logos/dd_logo_horizontal_mini.svg"
                alt="DreamDev"
                className="w-auto"
                style={{
                  height: '50px',
                }}
              />
            </a>

            {/* Social Media Links */}
            <div className="flex justify-center" style={{ gap: '36px' }}>
              <a
                href="https://www.linkedin.com/company/dreamdevio"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  src="/logos/linkedin.svg"
                  alt="LinkedIn"
                  style={{
                    width: '36px',
                    height: '36px',
                    filter: 'brightness(0) saturate(100%) invert(100%)'
                  }}
                />
              </a>
              <a
                href="https://x.com/dreamdevio"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  src="/logos/twitter.svg"
                  alt="X (Twitter)"
                  style={{
                    width: '36px',
                    height: '36px',
                    filter: 'brightness(0) saturate(100%) invert(100%)'
                  }}
                />
              </a>
              <a
                href="https://www.facebook.com/dreamdevio"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  src="/logos/facebook.svg"
                  alt="Facebook"
                  style={{
                    width: '36px',
                    height: '36px',
                    filter: 'brightness(0) saturate(100%) invert(100%)'
                  }}
                />
              </a>
              <a
                href="https://www.instagram.com/dreamdev.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  src="/logos/instagram.svg"
                  alt="Instagram"
                  style={{
                    width: '36px',
                    height: '36px',
                    filter: 'brightness(0) saturate(100%) invert(100%)'
                  }}
                />
              </a>
              <a
                href="https://bsky.app/profile/dreamdevtech.bsky.social"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  src="/logos/bluesky.svg"
                  alt="Bluesky"
                  style={{
                    width: '36px',
                    height: '36px',
                    filter: 'brightness(0) saturate(100%) invert(100%)'
                  }}
                />
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-2 sm:space-y-0 items-center lg:items-start">
              <a
                href="https://dreamdev.io/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline transition-colors duration-200"
                style={{
                  color: '#e9f7ff',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                  lineHeight: '19px'
                }}
              >
                Privacy policy
              </a>
              <a
                href="https://dreamdev.io/accessibility-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline transition-colors duration-200"
                style={{
                  color: '#e9f7ff',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                  lineHeight: '19px'
                }}
              >
                Accessibility statement
              </a>
              <a
                href="https://dreamdev.io/green-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline transition-colors duration-200"
                style={{
                  color: '#e9f7ff',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                }}
              >
                ESG Policy
              </a>
            </div>

            {/* Copyright */}
            <p
              className="text-sm text-center lg:text-left"
              style={{
                color: 'rgb(98, 116, 142)',
                fontFamily: 'Source Sans 3, sans-serif',
                letterSpacing: '0.15px',
                marginTop: '12px',
                fontSize: '16px',
                lineHeight: '19px'
              }}
            >
              DREAMDEV Technologies 2025 © All right reserved.
            </p>
          </div>

          {/* Middle Column - Contact Info */}
          <div className="flex flex-col space-y-6" style={{ maxWidth: '360px' }}>
            <div className="flex flex-col space-y-2">
              {/* Orange accent line */}
              <div
                className="w-8 h-0.5 mb-4"
                style={{
                  backgroundColor: '#FF5C3E'
                }}
              />
              <h5
                className="font-bold"
                style={{
                  color: 'rgb(206, 236, 255)',
                  fontSize: '18px',
                  fontWeight: '700',
                  fontFamily: 'Inter, sans-serif',
                  letterSpacing: '-0.04em',
                  lineHeight: '1.4em'
                }}
              >
                Contact Us
              </h5>
            </div>

            <div className="flex items-start space-x-3">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="w-4 h-4 mt-0.5 flex-shrink-0"
                style={{ color: 'rgb(206, 236, 255)' }}
              />
              <a
                href="mailto:info@dreamdev.io"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline transition-colors duration-200"
                style={{
                  color: 'rgb(206, 236, 255)',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                  lineHeight: '19px'
                }}
              >
                info@dreamdev.io
              </a>
            </div>

            <div className="flex items-start space-x-3">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="w-4 h-4 mt-0.5 flex-shrink-0"
                style={{ color: 'rgb(206, 236, 255)' }}
              />
              <p
                className="text-sm"
                style={{
                  color: 'rgb(206, 236, 255)',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                  lineHeight: '19px'
                }}
              >
                DreamDev Technologies Ltd, John Devoy Road, Naas, W91 FE8V, Kildare, Ireland
              </p>
            </div>

            <div className="flex items-start space-x-3">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="w-4 h-4 mt-0.5 flex-shrink-0"
                style={{ color: 'rgb(206, 236, 255)' }}
              />
              <p
                className="text-sm"
                style={{
                  color: 'rgb(206, 236, 255)',
                  fontFamily: 'Source Sans 3, sans-serif',
                  letterSpacing: '0.15px',
                  fontSize: '16px',
                  lineHeight: '19px'
                }}
              >
                International House, 10 Beaufort Court, Admirals Way, London, E14 9XL
              </p>
            </div>
          </div>

          {/* Right Column - Microsoft Partner */}
          <div className="flex flex-col space-y-6">
            <div className="mt-8 flex justify-end">
              <div
                className="w-32 h-20 rounded overflow-hidden"
                style={{
                  backgroundImage: 'url(https://framerusercontent.com/images/tcdYyvn475U9GIij8kB8EZ2A7A.png?width=660&height=433)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

